import React from "react";
import AvailabilityMineTableRow from "./AvailabilityMineTableRow.js";


export default function AvailabilityMineTable(props) {


  return (
    <div className="mt-12">
      <div className="flex items-center px-6">
        <div className="flex-auto">
          <h1 className="text-xl font-bold text-slate-900">Availability</h1>
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 overflow-x-auto min-w-full">
          <div className="inline-block min-w-full py-2 align-middle">
            <div className="overflow-hidden">
              <table className="min-w-full divide-y divide-slate-100">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="w-[25%] py-3 pl-6 pr-3 text-left text-xs font-semibold text-slate-500"
                    >
                      Day
                    </th>
                    <th
                      scope="col"
                      className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                    >
                      Existing Availability
                    </th>
                    <th
                      scope="col"
                      className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                    >
                      Requested Availability
                    </th>
                    <th
                      scope="col"
                      className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                    >
                      Effective Date
                    </th>
                    <th
                      scope="col"
                      className="w-[25%] pl-3 pr-6 py-3 text-xs font-semibold text-slate-500 text-right"
                    >
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 bg-white">
                  {props.myAvailabilityData?.map((item, index) => (
                    <AvailabilityMineTableRow
                      key={index}
                      day={item.day}
                      availability={item.availability}
                      availability2={item.availability2}
                      preferences={item.preferences}
                      requested={item.requested}
                      create_availability_request={
                        props.create_availability_request
                      }
                      delete_availability_request={
                        props.delete_availability_request
                      }
                      rescind_availability_request={
                        props.rescind_availability_request
                      }
                      permissionRole={props.permissionRole}
                      minEffectiveDate={props.minEffectiveDate}
                      storeTimezone={props.storeTimezone}
                    />
                  ))}
                </tbody>
              </table>
              <div className="border-b border-slate-100"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
